import React from "react";
import { Helmet } from "react-helmet";

/**
 * SEO component.
 *
 * @param {string}  title       Document title.
 * @param {string}  description Meta description.
 * @param {string}  canonical   Canonical URL (also used for og:url).
 * @param {string}  image       og:image / twitter:image URL.
 * @param {string}  ogType      Open Graph type (default "website").
 * @param {object|object[]} jsonLd Schema.org JSON-LD object(s).
 * @param {{name?:string, property?:string, content:string}[]} meta Extra meta tags.
 */
const Seo = ({
  title,
  description,
  canonical,
  image,
  ogType = "website",
  jsonLd,
  meta = [],
}) => {
  const jsonLdList = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <Helmet>
      {title ? <title>{title}</title> : null}
      {description ? <meta name="description" content={description} /> : null}
      {canonical ? <link rel="canonical" href={canonical} /> : null}

      {meta.map((m, i) =>
        m.property ? (
          <meta key={`m-${i}`} property={m.property} content={m.content} />
        ) : (
          <meta key={`m-${i}`} name={m.name} content={m.content} />
        ),
      )}

      {title ? <meta property="og:title" content={title} /> : null}
      {description ? (
        <meta property="og:description" content={description} />
      ) : null}
      <meta property="og:type" content={ogType} />
      {canonical ? <meta property="og:url" content={canonical} /> : null}
      {image ? <meta property="og:image" content={image} /> : null}

      <meta name="twitter:card" content="summary_large_image" />
      {title ? <meta name="twitter:title" content={title} /> : null}
      {description ? (
        <meta name="twitter:description" content={description} />
      ) : null}
      {image ? <meta name="twitter:image" content={image} /> : null}

      {jsonLdList.map((data, i) => (
        <script key={`ld-${i}`} type="application/ld+json">
          {JSON.stringify(data)}
        </script>
      ))}
    </Helmet>
  );
};

export default Seo;
